(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["layout_error.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("base.html", true, "layout_error.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("main"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_main(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n<div id=\"content\" style=\"float:none;width:auto;margin-left:10px;\">\r\n    <div id=\"catalog-title\" class=\"title-block\" style=\"margin-top:25px;\">\r\n        <h1>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "error.title"), env.opts.autoescape);
output += "</h1>\r\n    </div>\r\n    <div id=\"catalog-list\" style=\"margin-top:10px;padding-top:10px;\">";
context.getBlock("error_text")(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "</div>\r\n</div>\r\n";
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_error_text(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += runtime.suppressValue(env.getFilter("trans").call(context, runtime.contextOrFrameLookup(context, frame, "error_text")), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_main: b_main,
b_error_text: b_error_text,
root: root
};

})();
})();
